var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('menu-bar'),_c('content-View'),_c('features-view'),_c('services-info'),_c('banner-view'),_c('plan-view'),_c('footer-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }